import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { selectToken } from '../../util/tokenSelector.js';
import { Floater } from '../FloatingUI/Floater.js';
import { useThemeContext } from '../../contexts/session/Theme.js';

var _excluded = ["visible", "flex", "flexGrow", "flexShrink", "flexBasis", "width", "children", "onVisibilityChange", "flexWrapper", "autoHeightResize", "p", "usePortal", "hasInteractiveContent"];
var popoverPaddingMap = {
  s: '4',
  m: '8',
  l: '16'
};

/**
 * Popover gives extra information or allows specific actions related to a specific context. It offers easy access to important details or functions when needed.
 */
var Popover = /*#__PURE__*/React.memo(function (_ref) {
  var visible = _ref.visible,
    flex = _ref.flex,
    flexGrow = _ref.flexGrow,
    flexShrink = _ref.flexShrink,
    flexBasis = _ref.flexBasis,
    width = _ref.width,
    children = _ref.children,
    onVisibilityChange = _ref.onVisibilityChange,
    flexWrapper = _ref.flexWrapper,
    _ref$autoHeightResize = _ref.autoHeightResize,
    autoHeightResize = _ref$autoHeightResize === void 0 ? true : _ref$autoHeightResize,
    _ref$p = _ref.p,
    p = _ref$p === void 0 ? 'l' : _ref$p,
    usePortal = _ref.usePortal,
    hasInteractiveContent = _ref.hasInteractiveContent,
    rest = _objectWithoutProperties(_ref, _excluded);
  var theme = useThemeContext();
  var pointerColor = selectToken(theme.background, 'base.surface');
  var pointerPadding = selectToken(theme.spacing, '16');
  return /*#__PURE__*/React.createElement(Floater, _extends({
    visibleClass: "drone-po-vis",
    visible: visible,
    onVisibilityChange: onVisibilityChange,
    useFlexWrapper: true,
    pointerColor: pointerColor,
    pointerPadding: pointerPadding,
    childrenContainerProps: {
      display: 'flex',
      alignItems: 'center',
      flex: flex !== null && flex !== void 0 ? flex : 1,
      flexGrow: flexGrow,
      flexShrink: flexShrink,
      flexBasis: flexBasis
    },
    containerProps: {
      backgroundColor: 'base.surface',
      borderRadius: '8',
      width: width === 'content-fit' ? undefined : "".concat(width, "vw"),
      p: popoverPaddingMap[p]
    },
    flexWrapper: flexWrapper,
    autoHeightResize: autoHeightResize,
    usePortal: usePortal,
    hasInteractiveContent: hasInteractiveContent
  }, rest), children);
});
Popover.displayName = 'Popover';
Popover.defaultProps = {
  width: 'content-fit',
  interaction: 'click',
  pointerPosition: 'start-below',
  p: 'l',
  hasInteractiveContent: true
};

export { Popover };
//# sourceMappingURL=Popover.js.map
